<template>
  <Formulario :configs="configs"></Formulario>
</template>

<script>
import Formulario from "./components/Formulario";
export default {
  props: {
    source: String
  },
  components: {
    Formulario
  },
  data() {
    return {
      configs: {
        sistema: "",
        color: "",
        bgcolor: "",
        stylebgcolor: ""
      }
    };
  },
  mounted() {
    if (location.hostname.includes("appbeleza.com.br")) {
      this.configs.sistema = "AppBeleza";
      this.configs.color = "#801249";
      this.configs.bgcolor = "#600239";
      this.configs.stylebgcolor = "background-color: " + this.configs.bgcolor;
      this.configs.logo =
        "https://d3verit7xckkza.cloudfront.net/imgsystem/logo-appbeleza-site.png";
    } else {
      this.configs.sistema = "AppBarber";
      this.configs.color = "#0072bc";
      this.configs.bgcolor = "#00233c";
      this.configs.stylebgcolor = "background-color: " + this.configs.bgcolor;
      this.configs.logo =
        "https://d3verit7xckkza.cloudfront.net/imgsystem/logo-appbarber-login.png";
    }
  }
};
</script>